export default "__VITE_ASSET__B70RDCRQ__"